import { Button } from "@/components/ui/button";
import { Spinner } from "@/components/ui/spinner";
import type { Dictionary } from "../../../../dictionaries";
import { StatusOverlay, InfoCard, InfoRow } from "./status-overlay";

interface WaitingCardViewProps {
  paymentUrl: string;
  dictionary: Dictionary;
  onCancel: () => void | Promise<void>;
}

export function WaitingCardView({
  paymentUrl,
  dictionary,
  onCancel,
}: WaitingCardViewProps) {
  const { waiting } = dictionary;

  return (
    <StatusOverlay
      icon={<Spinner className="size-10" />}
      title={waiting.card.title}
      description={waiting.card.description}
      cancelLabel={waiting.cancel}
      onCancel={onCancel}
    >
      <InfoCard>
        <InfoRow className="text-sm text-muted-foreground">
          {waiting.card.warning}
        </InfoRow>
      </InfoCard>
      {/* In case the browser did not follow the automatic redirect. */}
      {paymentUrl && (
        <Button asChild variant="outline">
          <a href={paymentUrl}>{waiting.card.continue}</a>
        </Button>
      )}
    </StatusOverlay>
  );
}
